<template>
    <div class="kid_deal_Box">
      <div v-if="$i18n.locale == 'ar'">
        <h2>سياسة مكافحة استغلال الأطفال جنسيًا</h2>
          <p>تطبق  Pocket  سياسة "عدم التسامح مطلقًا" ضد أي محتوى يتعلق باستغلال الأطفال جنسيًا أو أي محتوى قد يكون ضارًا بالقاصرين. لا يجوز للمستخدمين استخدام خدمات  Pocket  لإنشاء أو نشر أو إعادة إنتاج أو نقل أو توزيع أو تخزين مثل هذا المحتوى، والذي يشمل، على سبيل المثال لا الحصر:</p>
          <p>
            <span>-إضفاء الطابع الجنسي على القاصرين:</span>
            يشمل المحتوى الجنسي الصريح الذي يظهر القاصرين، والمحتوى الذي يستغل القاصرين جنسيًا.
          </p>
          <p>
            <span>-الأفعال الجنسية المتعلقة بالقاصرين:</span>
            يشمل المحتوى الذي يظهر قاصرًا يشارك في أنشطة جنسية أو يشجع القاصرين على القيام بمثل هذه الأنشطة.
          </p>
          <p>
            <span>-المحتوى المضلل:</span> يشمل المحتوى الذي يستهدف القاصرين الصغار ولكنه يحتوي على:
          </p>
          <div>  -مواضيع جنسية</div>
          <div>   -عنف جنسي</div>
          <div>   -مواد فاحشة</div>
          <p>وأي محتوى آخر يحتوي على مواضيع غير ملائمة تتعلق بالبالغين أو غير مناسبة للعمر مثل العنف والجنس وغيرها.</p>
          <p>في حال تم إعلامنا باستخدام خدماتنا لتخزين أو نقل أي محتوى من هذا النوع، سنتخذ إجراءات فورية لإزالة جميع هذه المحتويات، وحظر الحسابات ذات الصلة، والإبلاغ عن جميع الأنشطة المرتبطة إلى السلطات المختصة. تحتفظ  Pocket  بالحق في اتخاذ إجراءات إضافية، بما في ذلك التعاون مع وكالات إنفاذ القانون والهيئات الحكومية لمساعدتها في ملاحقة المتورطين.</p>
          <p>إذا كنت على علم بوجود محتوى استغلال الأطفال جنسيًا أو محتوى غير قانوني على موقع  Pocket ، يرجى الإبلاغ عبر البريد الإلكتروني: billionairepte@gmail.com، مع تقديم معلومات كافية تمكن فريقنا من تحديد مكان المادة.</p>
          <p>
            مصادر إضافية:
          </p>
          <p>إذا كنت على علم باستغلال الأطفال أو إساءة معاملتهم في أماكن أخرى على الإنترنت أو خارجها، نوصي بالتواصل مع أحد الجهات التالية بناءً على موقعك الجغرافي:</p>
          <p>
            <a href="https://www.missingkids.org/gethelpnow/cybertipline">-أمريكا الشمالية، أستراليا، نيوزيلندا:المركز الوطني للأطفال المفقودين والمستغلين (NCMEC)</a>
          </p>
          <p>
            <a href="https://www.europol.europa.eu/report-a-crime/law-enforcement-reporting-channels-child-sexual-coercion-and-extortion">-أوروبا: قنوات الإبلاغ عن الاستغلال الجنسي للأطفال والابتزاز</a>
          </p>
          <p>
            <a href="https://www.icmec.org/education-portal/reporting-mechanisms/">-أمريكا الجنوبية وغيرها: الخط الساخن للمركز الدولي للأطفال المفقودين والمستغلين (ICMEC)</a>
          </p>
      </div>
      <div v-else>
        <h2>Child Sexual Abuse Policy</h2>
          <p>Pocket has a Zero Tolerance Policy against child sexual abuse content or any content that can be harmful to minors. Users may not use Pocket’s services to create, publish, reproduce, transmit, distribute, or store such content, which includes but is not limited to:</p>
          <p>
            <span>Sexualization of minors:</span>
            Sexually explicit content featuring minors and content that sexually exploits minors.
          </p>
          <p>
            <span>Sexual acts involving minors:</span>
            Content showing a minor participating in sexual activities or encouraging minors to do sexual activities.
          </p>
          <p>
            <span>Misleading content:</span>Content that targets young minors, but contains:
          </p>
          <div>  - Sexual</div>
          <div>  - Sexual violence</div>
          <div>  - Obscenity</div>
          <p>Other contents contain adult or age-inappropriate themes such as violence, sex, and more.</p>
          <p>If, however, we are made aware that our services have been used to store and/or transmit any content of that kind, we act immediately to remove any and all such content, block the user accounts involved and report all related activity to authorities. Pocket hereby reserves the right to take further action including but not limited to cooperation with law enforcement agencies and/or government bodies to assist them in prosecuting those involved.</p>
          <p>If you are aware of child sexual abuse content or illegal content on the Pocket website, please report to billionairepte@gmail.com, with the information reasonably sufficient to permit Pocket to locate the material.</p>
          <p>
            Additional Resources:
          </p>
          <p>If you become aware of child exploitation or abuse of minors elsewhere on the internet or offline, we recommend you contact one of the following, based on your location:</p>
          <p>North America, Australia, New Zealand:
            <a href="https://www.missingkids.org/gethelpnow/cybertipline">National Center for Missing & Exploited Children (NCMEC)</a>
          </p>
          <p>Europe:
            <a href="https://www.europol.europa.eu/report-a-crime/law-enforcement-reporting-channels-child-sexual-coercion-and-extortion">Law Enforcement Reporting Channels for Child Sexual Coercion and Extortion</a>
          </p>
          <p>South America and other locales: 
            <a href="https://www.icmec.org/education-portal/reporting-mechanisms/">International Centre for Missing & Exploited Children global hotline</a>
          </p>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "kid_deal_Box",
    data() {
      return {
        langType:'en',
      };
    },
    created() {
        this.langType = this.$route.query.langType || 'en';
        this.language()
    },
    mounted() {
    },
    methods: { 
        language() {
            let langs = this.langType.substring(0, 2);
            if (langs == "ar") {
                this.$i18n.locale = "ar";
                document.title = 'سياسة مكافحة استغلال الأطفال جنسيًا'
            } else {
                this.$i18n.locale = "en";
                document.title = 'Child Sexual Abuse Policy'
            }
            document.querySelector("html").setAttribute("lang", this.$i18n.locale);
        },
    },
  };
  </script>
  
  <style scoped>
html[lang="ar"] .kid_deal_Box {
  direction: rtl;
}
  * {
    margin: 0;
    padding: 0;
  }
  .kid_deal_Box{
    font-family: 'Montserrat';
    padding: 40px;
    width: 100%;
    box-sizing: border-box;
    position: relative;
    color: #262427;
    word-wrap: break-word;
  }
  h2{
    font-size: 36px;
    font-weight: 700;
    text-align: center;
  }
  p{
    margin-bottom: 16px;
  }
  p,div{
    font-size: 28px;
    font-weight: 500;
    line-height: 44px;
  }
  p span{
    font-size: 32px;
    font-weight: 600;
  }
  </style>
  